<template>
  <div class="documents">
    <div class="documents__manage">
      <div class="documents__add-button" v-if="$can('manage', 'document')">
        <vs-button
          icon="add"
          type="flat"
          @click="popupActive = true"
          >Add document</vs-button
        >
      </div>
    </div>
    <DocumentsList @deleteDocument="deleteDocument" />
    <vs-popup
      class="form-popup documents__popup"
      classContent="documents__popup-content"
      title="New document"
      :active.sync="popupActive"
      @close="closePopup"
    >
      <DocumentForm v-if="popupActive" @closePopup="closePopup" />
    </vs-popup>
  </div>
</template>

<script>
import DocumentsList from '@/components/documents/documentsList.vue'
import DocumentForm from '@/components/documents/documentForm.vue'
import { mapState } from 'vuex'

export default {
  title: 'SE-Docs',
  data() {
    return {
      popupActive: false,
    }
  },
  computed: {
    ...mapState({
      documents: state => state.documents.documents,
    }),
  },
  components: { DocumentsList, DocumentForm },
  created() {
    this.getDocuments()
  },
  methods: {
    getDocuments: function() {
      this.$store.dispatch('documents/getDocumentsAction').catch(r => {
        this.$vs.notify({
          title: 'Error',
          text: r.message,
          color: 'danger',
          position: 'top-right',
        })
      })
    },
    deleteDocument: function(id) {
      this.$store
        .dispatch('documents/deleteDocumentAction', id)
        .then(() => {
          this.$vs.notify({
            title: 'Removed',
            text: `Document removed`,
            color: 'success',
            position: 'top-right',
          })
        })
        .catch(r => {
          this.$vs.notify({
            title: 'Error',
            text: r.message,
            color: 'danger',
            position: 'top-right',
          })
        })
    },
    closePopup: function() {
      this.popupActive = false
      this.getDocuments()
    },
  },
}
</script>

<style lang="scss">
.documents {
  &__manage {
    display: flex;
    flex-flow: row nowrap;
  }
  &__add-button {
    flex: 1;
    button {
      margin-bottom: 10px;
    }
  }
}
</style>
